const avatars = [
  {
    key: "3bf676f1-6af0-4c03-95d0-414bb346a985",
    avatarName: "Avatar01",
  },
  {
    key: "6d955437-a514-427e-854b-c775acbeffa3",
    avatarName: "Avatar03",
  },
  {
    key: "a078c615-bea1-481e-899b-3a3de8a87179",
    avatarName: "Avatar04",
  },
  {
    avatarName: "Avatar05",
    key: "9527fdde-1d88-4d2d-aa4a-ec77a48ab987",
  },
  {
    avatarName: "Avatar06",
    key: "29ac8e88-33fd-48ce-bd6d-678e83ee9927",
  },
  {
    avatarName: "Avatar07",
    key: "5f775797-2048-425e-a405-32e578d5f44c",
  },
  {
    avatarName: "Avatar08",
    key: "5d2595f3-30ea-4ae7-85c7-f776789e14cd",
  },
  {
    avatarName: "Avatar09",
    key: "1a71b478-e505-41cf-930c-d3c943804a18",
  },
  {
    avatarName: "Avatar10",
    key: "0925960e-771c-4d3f-bb84-aa9307d3aa3c",
  },
  {
    avatarName: "Avatar11",
    key: "d449e271-813c-4f6a-af56-625c879b6246",
  },
  {
    avatarName: "Avatar12",
    key: "37c3a835-e07e-4c48-9a6b-3130e3d67709",
  },
  {
    avatarName: "Avatar13",
    key: "91316007-7d97-400e-8df7-0645df1fe57b",
  },
  {
    avatarName: "Avatar14",
    key: "df267701-2a6e-47cd-9795-02d0ecdfa515",
  },
  {
    avatarName: "Avatar15",
    key: "0e026c6e-b619-4ceb-8578-86a5277064cb",
  },
  {
    avatarName: "Avatar16",
    key: "04f444ce-f259-476b-a98b-141cb6d959d1",
  },
  {
    avatarName: "Avatar17",
    key: "e5ee3e0e-3970-46e2-850f-f3d8eafa018a",
  },
  {
    avatarName: "Avatar18",
    key: "5a684459-34e9-45e8-8e75-571db3eb7e55",
  },
  {
    avatarName: "Avatar19",
    key: "84b6917b-c0da-463e-ac75-9c667426df2f",
  },
  {
    avatarName: "Avatar20",
    key: "786ddd95-4acc-4f76-a16b-42954161dab6",
  },
  {
    avatarName: "Avatar21",
    key: "255ab671-e7ff-432c-b609-5cda243f6e20",
  },
];

export default avatars;
